import React from 'react';
import ReactDOM from 'react-dom/client';

import Card from './App';
import reportWebVitals from './reportWebVitals';
import MyData from './MyData';



function netflixCards(value) {
  return (
    <Card
      key ={value.id}
      imglink={value.imglink}
      title={value.title}
      netflix={value.netflix}
      link={value.link}
    />
  )
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <>
      <div className="one">
        <h1>Top Amazon & Netflix Series</h1>
      </div>
      {MyData.map(netflixCards)}
      
      
    </>
  </React.StrictMode>
);


reportWebVitals();
